import Attribute from '@/models/general/settings/RoadcubeMarket/Attribute';

const getDefaultState = () => ({
  attribute: new Attribute(),
  attributes: [],
});
export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setAttributes(state, payload) {
      state.attributes = payload || [];
    },

    setAttribute(state, payload) {
      state.attribute = new Attribute(payload);
    },
  },

  actions: {
    async getAttributes({ commit }, q = '') {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await Attribute.getAttributes(q);
        commit('setAttributes', data.data);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex?.response?.data);
      }
    },

    async create({ commit, dispatch }, body) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await Attribute.createAttribute(body);
        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex?.response?.data);
      }
    },

    async update({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await Attribute.updateAttribute(body.attribute_id, body);
        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex?.response?.data);
      }
    },

    async delete({ commit }, id) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await Attribute.deleteAttribute(id);
        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex?.response?.data);
      }
    },
  },
};
